export default __webpack_public_path__ + "slices/main/assets/public/media/shelb-invision.5d4833b22a44bb95c0e271d556c357bb.png";